<template>
  <v-container id="user-list">
    <v-row>
      <v-col>Usuários do Sistema</v-col>
      <v-col class="text-right">
        <v-btn outlined color="primary" class="ml-3" :to="'/usuario/novo'">
          Novo Usuário
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Nome do usuário"
          name="nome"
          type="text"
          required
          v-model="filter.nome"
          clearable
        ></v-text-field>
      </v-col>

      <v-col>
        <app-city-combobox :filter="filter"></app-city-combobox>
      </v-col>

      <v-col>
        <app-group-combobox
          :filter="filter"
          :idsToFilter="groupsHierarquia"
        ></app-group-combobox>
      </v-col>

      <v-col>
        <app-axis-combobox :filter="filter"></app-axis-combobox>
      </v-col>

      <v-col>
        <v-btn outlined color="primary" class="ml-3" @click="listUsers()">
          <span>Filtrar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="usuarios"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.nome="{ item }">
            <a
              :href="'./#/usuario/editar/' + item.usuarioId"
              v-if="!isAnalista || item.grupoId === 2"
              >{{ item.nome }}</a
            >
            <span v-else>{{ item.nome }}</span>
          </template>

          <template slot="no-data">
            <span> Nenhum usuário retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { userAPI } from "./UserAPI";
import { groupsAPI } from "@/modules/groups";

import { mapGetters, mapActions } from "vuex";
import { AppCityCombobox } from "@/modules/city";
import { AppGroupCombobox } from "@/modules/user";
import { AppAxisCombobox } from "@/modules/axis";

export default {
  components: {
    AppCityCombobox,
    AppGroupCombobox,
    AppAxisCombobox,
  },
  computed: {
    ...mapGetters(["user", "isAnalista", "isFullAdmin"]),
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "nome" },
        { text: "CPF", value: "cpf" },
        { text: "E-mail", value: "email" },
        { text: "Grupo", value: "grupo.nome" },
        { text: "Ações", value: "acoes" },
      ],
      usuarios: [],
      groupsHierarquia: [],
      filter: {},
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    listUsers() {
      userAPI
        .getByFilter(this.filter)
        .then((resp) => {
          this.usuarios = resp.data;
          this.getHierarquia(this.user.grupoId);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter usuários");
        });
    },
    getHierarquia(groupId) {
      groupsAPI
        .getOne(groupId)
        .then((resp) => {
          const { hierarquia } = resp.data;
          this.groupsHierarquia = (hierarquia && JSON.parse(hierarquia)) || [];
          if (!this.isFullAdmin) {
            this.usuarios = this.usuarios.filter((user) =>
              this.groupsHierarquia.some(
                (hie) => hie.usuarioGrupoId === user.grupoId
              )
            );
          }

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao achar hierarquia usuário");
        });
    },
  },
  async mounted() {
    this.setLoading(true);
    this.listUsers();
  },
};
</script>
